module.exports = __webpack_public_path__ + "static/media/icon-user-circle.71046aa1.svg";